import request from '@/utils/request';
export function fetchCode() {
  return request({
    url: '/userservice/api/user/getCode',
    method: 'get'
  });
} // 验证账号

export function getUserInfoByAcc(data) {
  return request({
    url: '/userservice/api/person/getUserInfoByAcc',
    method: 'post',
    data: data
  });
} // 获取短信验证码

export function sendCodePwdSMS(data) {
  return request({
    url: '/userservice/api/person/sendCodePwdSMS',
    method: 'post',
    data: data
  });
} // 验证短信验证码

export function validationCodeSMS(data) {
  return request({
    url: '/userservice/api/person/validationCodeSMS',
    method: 'post',
    data: data
  });
} // 修改密码

export function updatePwdByAccPhone(userName, userPwd) {
  var data = {
    userName: userName,
    userPwd: userPwd
  };
  return request({
    url: '/userservice/api/person/updatePwdByAccPhone',
    method: 'post',
    data: data
  });
}